// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "-legacy." + {"265":"f662b41a","297":"1c758e3b","310":"bac2a853","436":"9a47eb5a","540":"238d75ef","643":"b7827dc5","787":"59a476f4","849":"f76aafed","854":"6459c194","944":"58b610f1"}[chunkId] + ".js";
};